import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {FasciaOrariaGG} from "@commons/mapping/FasciaOrariaGG";
import {UserTrace} from "@commons/types";
import {Coppia} from "@commons/mapping/Calc";

export type TipoFascia = "ALTRO" | "FASCIA_DIURNA" | "FASCIA_NOTTURNA";

export interface FasciaOrariaWeekRecord extends URIAndTrace {
    idAzienda: number;
    idFasciaOraria: number;
    descrizione: string;
    tipo: TipoFascia;
    lunedi: FasciaOrariaGG;
    martedi: FasciaOrariaGG;
    mercoledi: FasciaOrariaGG;
    giovedi: FasciaOrariaGG;
    venerdi: FasciaOrariaGG;
    sabato: FasciaOrariaGG;
    domenica: FasciaOrariaGG;
    insertTrace: UserTrace;
    lastUpdateTrace: UserTrace;
}

export class FasciaOrariaWeekRecord {
    static getCoppia = (that: FasciaOrariaWeekRecord, index: number): Coppia => {

        switch (index) {
            case 1:
                return new Coppia(FasciaOrariaGG.getInizio(that.lunedi), FasciaOrariaGG.getFine(that.lunedi));
            case 2:
                return new Coppia(FasciaOrariaGG.getInizio(that.martedi), FasciaOrariaGG.getFine(that.martedi));
            case 3:
                return new Coppia(FasciaOrariaGG.getInizio(that.mercoledi), FasciaOrariaGG.getFine(that.mercoledi));
            case 4:
                return new Coppia(FasciaOrariaGG.getInizio(that.giovedi), FasciaOrariaGG.getFine(that.giovedi));
            case 5:
                return new Coppia(FasciaOrariaGG.getInizio(that.venerdi), FasciaOrariaGG.getFine(that.venerdi));
            case 6:
                return new Coppia(FasciaOrariaGG.getInizio(that.sabato), FasciaOrariaGG.getFine(that.sabato));
            case 7:
                return new Coppia(FasciaOrariaGG.getInizio(that.domenica), FasciaOrariaGG.getFine(that.domenica));
            default:
                return new Coppia(0, 2400);
        }
    };

}